import React from 'react';
import { Card } from '@naf-simba/sections-cards';
import { AdvancedImage, lazyload } from '@cloudinary/react';
import { getCardMemberLabel } from '@lib/getCardMemberLabel';
import { ConsumerGuideDetail } from '../../../../../../types/consumerTestType';
import { useCloudinary } from '../../../../hooks/Cloudinary/useCloudinary';
import { StyledLink } from '../../../../components/styled-link/StyledLink';
import defaultImage from '../../../../../assets/images/defaultLocalArticle.svg?url';
import * as S from './Styles';

export const ConsumerTestCard = ({ test }: { test: ConsumerGuideDetail }) => {
  const { slug, image, title, ingress, paywallDetails } = test;
  const link = `/forbrukertester/${slug}`;
  const imageAlt = image?.altText;
  const { getProcessedImage } = useCloudinary();
  const itemImage = getProcessedImage(image?.publicId, {
    width: 768,
    height: 432,
    focusMethod: image?.focus,
    quality: 'auto:eco',
  });

  const localImage = defaultImage;

  return (
    <S.CardGridWrapper s="12" m="12" l="4" xl="4" key={`consumertest-item-${title}`}>
      <StyledLink to={link} $hasCardGrid>
        <Card
          titleAs="h2"
          title={title}
          description={ingress}
          media={
            itemImage
              ? {
                  render: () => (
                    <AdvancedImage
                      alt={imageAlt || ''}
                      cldImg={itemImage}
                      plugins={[lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 })]}
                    />
                  ),
                }
              : { src: localImage, alt: '' }
          }
          date=" "
          label={getCardMemberLabel(paywallDetails)}
        />
      </StyledLink>
    </S.CardGridWrapper>
  );
};
